import utils from '../libs/utils';
import axios from './axios';

const baseUrl = 'v1/erp-business-web';
export default {
  axios,
  getInventoryUnpackList(params) {
    return axios.get(`${baseUrl}/inventoryUnpack/list?${utils.exchangeParams(params)}`);
  },
  downloadUnpackReport(params) {
    return axios.get(`${baseUrl}/inventoryUnpack/downloadUnpackRecord?${utils.exchangeParams(params)}`);
  },
  getUnpackableGoodsList(params) {
    return axios.get(`${baseUrl}/inventoryUnpack/listUnpackableGoods?${utils.exchangeParams(params)}`);
  },
  updateUnpackList(token,params) {
    return axios.post(`${baseUrl}/inventoryUnpack/add?token=${token}`,utils.exchangeParams(params));
  },
  getUnpackInventoryList(params) {
    return axios.get(`${baseUrl}/inventoryUnpack/listUnpackInventory?${utils.exchangeParams(params)}`);
  },
  downloadUnpackInventory(params) {
    return axios.get(`${baseUrl}/inventoryUnpack/listUnpackInventory/download?${utils.exchangeParams(params)}`);
  },
  getUnpackDetailReportList(params) {
    return axios.get(`${baseUrl}/saleReport/listUnpackDetailReport?${utils.exchangeParams(params)}`);
  },
  downloadUnpackDetailReport(params) {
    return axios.get(`${baseUrl}/saleReport/downloadUnpackDetailReport?${utils.exchangeParams(params)}`, {
      responseType: 'blob',
    });
  },
  getUnpackDetailSummary(params) {
    return axios.get(`${baseUrl}/saleReport/getUnpackDetailSummary?${utils.exchangeParams(params)}`);
  },
};
